import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Button } from "@/components/ui/button";
import { PoweredBy } from "@/components/PoweredBy";
import { toast } from "sonner";
import { ArrowLeft, CalendarPlus, Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const cabin = (() => { try { return JSON.parse(localStorage.getItem("sf_cabin") || "null"); } catch { return null; } })();

export default function CabinMeetings() {
  const navigate = useNavigate();
  const token = localStorage.getItem("sf_cabin_token");
  const [list, setList] = useState(null);
  useEffect(() => {
    if (!token) { navigate("/login"); return; }
    axios.get(`${API}/public/cabin/my/meetings`, { headers: { Authorization: `Bearer ${token}` } }).then((r) => setList(r.data)).catch(() => setList([]));
  }, []);

  return (
    <div className="min-h-screen bg-slate-100">
      <header className="bg-navy-900 px-5 py-4"><button onClick={() => navigate("/cabin-portal")} className="text-blue-100/80 hover:text-white flex items-center gap-1.5 text-sm"><ArrowLeft size={16} /> Portal</button></header>
      <main className="max-w-lg mx-auto px-4 py-6">
        <h1 className="font-display text-xl font-bold text-navy-900 mb-1">Meeting Room Booking</h1>
        <p className="text-sm text-slate-500 mb-4">Upcoming bookings</p>
        {!list ? <div className="flex justify-center py-8"><Loader2 className="animate-spin text-navy-900" /></div> : list.length === 0 ? (
          <div className="bg-white rounded-2xl border border-slate-200 p-6 text-center text-slate-500 text-sm">No upcoming room bookings.</div>
        ) : list.map((m) => (
          <div key={m.id} className="bg-white rounded-2xl border border-slate-200 p-4 mb-3" data-testid={`meeting-card-${m.id}`}>
            <div className="flex items-center justify-between"><p className="font-semibold text-navy-900">{m.room_name}</p><span className="text-xs font-semibold px-2 py-0.5 rounded-full bg-emerald-100 text-emerald-700">{(m.status || "").replace("_", " ")}</span></div>
            <p className="text-sm text-slate-500">{m.date} · {m.start_time}–{m.end_time}</p>
            {m.purpose && <p className="text-xs text-slate-400 mt-1">{m.purpose}</p>}
          </div>
        ))}
        <Button onClick={() => cabin?.branch_public_id ? navigate(`/book/branch/${cabin.branch_public_id}`) : toast.error("Not configured")} data-testid="book-room-btn" className="w-full h-12 bg-navy-900 hover:bg-navy-800 mt-4"><CalendarPlus size={16} className="mr-2" /> Book Meeting Room</Button>
        <div className="mt-8 flex justify-center"><PoweredBy /></div>
      </main>
    </div>
  );
}
